/**
 * Pure helper logic for the "Pay all" button on MyAccount.js (KBT-169).
 * No React, no network — kept separate so the decision of when to show
 * the button, and what total to display, is unit-testable on its own.
 */

const toAmount = (invoice) => {
  const n = Number(invoice && invoice.total);
  return Number.isFinite(n) ? n : 0;
};

// Only worth offering "Pay all" when there's more than one open invoice
// AND there's actually something payable (a single Pay button already
// covers the one-invoice case).
export const canPayAll = (openInvoices) => {
  const invoices = openInvoices || [];
  if (invoices.length <= 1) return false;
  return invoices.some((inv) => toAmount(inv) > 0);
};

export const getPayAllSummary = (openInvoices) => {
  const invoices = openInvoices || [];
  const total = invoices.reduce((sum, inv) => sum + toAmount(inv), 0);
  return { count: invoices.length, total };
};
